import { useTransaction } from "hooks/useTransactions";
import Action from "pages/_components/Action";
import Button from "pages/_components/Button";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { actions as echeckActions } from "reducers/echecks";
import { bool } from "prop-types";
import { isIOS } from "react-device-detect";
import EcheckRequestSummaryBody from "./components/Summary";

const EcheckRequestTransactionPage = ({ isDesktop }) => {
    const { state = {} } = useLocation();
    const { isFlowComplete = false } = state;

    const formatTransactionData = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        `/echecks/requestAmount/confirm`,
        echeckActions.setRequestEcheckAmountData,
        echeckActions.cleanEcheckTicket,
        formatTransactionData,
    );
    const { componentRef, handlePrint, handlePrintMobile, mobileRef, handleShareMobile } = useReactPrint(
        "echecks.request.title",
        id,
        "requestEcheqTransaction",
    );

    const { isFinished, isBackoffice } = status;
    const backLinkTo = isFlowComplete ? "/echecks" : "";
    const backofficePending = transaction?.data?.backofficePending;
    const subtitle = backofficePending ? "pending.approval" : "accounts.create.transactionRequest.firstTitle";

    useEffect(
        () => () => {
            if (isFlowComplete) {
                dispatch(echeckActions.setRequestEcheckAmountData({}));
            }
        },
        [],
    );

    return (
        <>
            <Notification scopeToShow="requestEcheqTransaction" />
            {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle="echecks.request.title" backLinkTo={backLinkTo}>
                    {isFinished && (
                        <>
                            <DesktopButtons>
                                <Button
                                    className="btn btn-outline"
                                    image="images/figma/icon/download.svg"
                                    label="global.download"
                                    onClick={handlePrint}
                                    block={false}
                                />
                            </DesktopButtons>
                            <MobileButtons
                                image={
                                    isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"
                                }>
                                <Action labelKey="global.download" handleClick={handlePrintMobile} />
                                <Action labelKey="global.share" handleClick={handleShareMobile} />
                            </MobileButtons>
                        </>
                    )}
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader
                                title="echecks.request.title"
                                subTitle={transaction?.idTransactionStatus === "PENDING" ? subtitle : null}
                            />
                            <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                                <EcheckRequestSummaryBody
                                    ticket
                                    isDesktop={isDesktop}
                                    backofficePending={backofficePending}
                                />
                            </Col>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                />
                            </Col>
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

EcheckRequestTransactionPage.propTypes = {
    isDesktop: bool,
};

EcheckRequestTransactionPage.defaultProps = {
    isDesktop: false,
};

export default EcheckRequestTransactionPage;
